import React from 'react'
import LogoWhite from '../../images/logo_vertical.svg'
import { Link } from 'react-router-dom'

const LandingFooter = (): JSX.Element => {
  return (
    <div
      className={
        'flex w-full justify-between items-center py-24 px-8 xl:px-16 bg-blue-primary font-Spartan'
      }>
      <div
        className={
          'flex flex-col lg:flex-row w-full mx-auto justify-between items-center gap-8 lg:gap-0'
        }>
        <div className={'flex items-center'}>
          <img src={LogoWhite} alt="logo" className={'h-24 w-24 object-cover'} />
        </div>
        <div
          className={
            'flex flex-1 flex-col md:flex-row gap-8 justify-center items-center text-white font-medium w-full mx-auto text-sm'
          }>
          <a href={'/terms'} target={'_blank'} rel={'noreferrer'}>
            Terms
          </a>
          <a href={'/privacy-notice'} target={'_blank'} rel={'noreferrer'}>
            Privacy
          </a>
          <a
            href={'https://calendly.com/demand-local/link1data'}
            target={'_blank'}
            rel={'noreferrer'}>
            Contact us
          </a>
        </div>
      </div>
    </div>
  )
}

export default LandingFooter
